const WAVE_BANDS = [
  { y: 18, delay: 0, dur: 4.6, opacity: 0.38 },
  { y: 26, delay: 1.1, dur: 5.4, opacity: 0.28 },
  { y: 33, delay: 0.45, dur: 5.0, opacity: 0.22 },
];

function wavePath(y) {
  return `M-20 ${y} Q -5 ${y - 3.5} 10 ${y} T 40 ${y} T 70 ${y} T 100 ${y} T 130 ${y}`;
}

export default function AmbianceSeashoreAtmosphere() {
  return (
    <span
      className="mode-tile__atmosphere mode-tile__atmosphere--seashore"
      aria-hidden="true"
    >
      <svg
        className="mode-tile__seashore-svg"
        viewBox="0 0 100 40"
        preserveAspectRatio="none"
        focusable="false"
      >
        {WAVE_BANDS.map((band, index) => (
          <path
            key={`wave-${index}`}
            className="mode-tile__seashore-wave"
            d={wavePath(band.y)}
            style={{
              opacity: band.opacity,
              animationDelay: `${band.delay}s`,
              animationDuration: `${band.dur}s`,
            }}
          />
        ))}
      </svg>
    </span>
  );
}
